import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, phoneRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import { isArray } from 'class-validator';

const useForm = ({ role }) => {
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();
  const [establishments, setEstablishments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.params && location.params.id) {
      if (role !== 'ESTABLISHMENT_USER') {
        getEstablishments();
      }
      getEstablishmentUser();
    } else {
      history.push('/establishment-user');
    }
  }, []);

  const back = () => {
    history.goBack();
  };

  const getEstablishments = () => {
    setLoading(true);
    AxiosInstance.get('/establishment', { params: { limit: 500, page: 0 } })
      .then((res) => {
        setEstablishments(res.data.items);
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_GET_ESTABLISHMENT'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getEstablishmentUser = () => {
    setLoading(true);
    AxiosInstance.get('/establishment-user/' + location.params.id)
      .then((response) => {
        let inputValues = {
          firstName: response.data.user.firstName,
          lastName: response.data.user.lastName,
          email: response.data.user.email,
          gender: response.data.user.gender,
          phone: response.data.user.phone,
          establishmentId: role === 'ESTABLISHMENT_USER' ? null : response.data.establishment,
        };
        updateFormState(inputValues);
      })
      .catch((error) => {
        Swal.fire(t('establishment-user.ERROR_GET_ESTABLISHMENT_USER'), '', 'error');
        history.push('/establishment-user');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateEstablishmentUser = () => {
    setLoading(true);
    let establishmentId = null;
    if (role !== 'ESTABLISHMENT_USER') {
      if (formState.inputValues.establishmentId && formState.inputValues.establishmentId.id)
        establishmentId = formState.inputValues.establishmentId.id;
      else establishmentId = formState.inputValues.establishmentId;
    }

    AxiosInstance.patch('/establishment-user/' + location.params.id, {
      firstName: formState.inputValues.firstName,
      lastName: formState.inputValues.lastName,
      gender: formState.inputValues.gender,
      email: formState.inputValues.email,
      phone: formState.inputValues.phone,
      establishmentId: establishmentId,
    })
      .then((res) => {
        Swal.fire(t('establishment-user.SUCCESS_UPDATE_ESTABLISHMENT_USER'), '', 'success');
      })
      .catch((error) => {
        const messages = error?.data?.message;
        if (error.status === 400 && messages) {
          handleErrorsServer(messages);
          const text = Array.isArray(messages) ? messages[0] : messages;
          Swal.fire(t(text) || t('establishment-user.ERROR_UPDATE_ESTABLISHMENT_USER'), '', 'error');
        } else {
          Swal.fire(t('establishment-user.ERROR_UPDATE_ESTABLISHMENT_USER'), '', 'error');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const inputValues = {
    firstName: { value: '', validate: { required: true } },
    lastName: { value: '', validate: { required: true } },
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    phone: { value: '', validate: { required: true, pattern: phoneRegex } },
    gender: { value: '', validate: { required: true } },
    establishmentId: { value: '', validate: { required: role === 'ESTABLISHMENT_USER' ? false : true } },
  };

  const { formState, submitHandler, updateFormState, field, handleErrorsServer } = FormState(
    inputValues,
    updateEstablishmentUser
  );

  return {
    submitHandler,
    back,
    field,
    establishments,
    loading,
  };
};

export default useForm;
